module.exports = __webpack_public_path__ + "static/img/09_lsym.e49a7f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/secondLine/09_lsym.png
// module id = hSFW
// module chunks = 0